// Which transcription engine is active. Resolution order:
//   1. explicit ?engine=deepgram|google|webspeech  → always wins (A/B + forcing)
//   2. otherwise auto-route: Chrome (Web Speech works) → 'webspeech' (free);
//      any other browser → the configured fallback engine, if REACT_APP_STT_FALLBACK
//      is set. The env gate keeps Phase 1 (no relay deployed) Chrome-only, and lets
//      Phase 1b flip non-Chrome over to the streaming relay just by setting the var.
// Shared so the game wiring and the debug indicator agree on one source of truth.

import { isSupportedBrowser } from '../lib/env'

export type SttEngine = 'webspeech' | 'deepgram' | 'google'

// NB: use `process.env.REACT_APP_*` directly — CRA inlines it to a string literal at
// build time. Do NOT guard with `typeof process !== 'undefined'`: webpack doesn't define
// a bare global `process`, so that guard is false at runtime and nukes the inlined value.
const FALLBACK = process.env.REACT_APP_STT_FALLBACK || ''

export const getSttEngine = (): SttEngine => {
  const e = typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('engine') : null
  if (e === 'deepgram' || e === 'google') return e
  if (e === 'webspeech') return 'webspeech'
  // Non-Chrome (Safari / Firefox / iOS / Edge — anything Web Speech can't run) routes
  // to the streaming fallback when one is configured; Chrome keeps the free engine.
  if ((FALLBACK === 'deepgram' || FALLBACK === 'google') && !isSupportedBrowser()) return FALLBACK
  return 'webspeech'
}

export const sttEngineLabel = (e: SttEngine): string => {
  switch (e) {
    case 'deepgram':
      return 'Deepgram (relay)'
    case 'google':
      return 'Google STT (relay)'
    default:
      return 'Chrome Web Speech (native)'
  }
}
